import { useMemo } from 'react'
import { useUnifiedBilling, refreshBilling } from '../store/global-billing'

/**
 * Hook to get the user's usage data with breakdown by billable metrics.
 */
export const useBillingUsage = () => {
  const billingState = useUnifiedBilling()

  return useMemo(
    () => ({
      data: billingState.usage ?? undefined,
      isLoading: billingState.paywall.isLoading,
      isFetching: billingState.paywall.isLoading,
      refetch: refreshBilling,
    }),
    [billingState.usage, billingState.paywall.isLoading],
  )
}

/**
 * Hook to get the user's credit consumption data.
 */
export const useBillingCreditConsumption = () => {
  const billingState = useUnifiedBilling()

  return useMemo(
    () => ({
      data: billingState.creditConsumption,
      isLoading: !!billingState.creditConsumption,
      isFetching: !!billingState.creditConsumption,
      refetch: refreshBilling,
    }),
    [billingState.creditConsumption],
  )
}
